<template>
  <v-app>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  data: function () {
    return {
      restaurantInfo: {},
    };
  },
}
</script>

<style>
.v-application--is-ltr .v-text-field .v-input__prepend-inner {
  padding-right: 8px !important;
}

</style>
